
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"context.update.message.title":"A map layer was deleted or unshared","context.update.message.text":"Thus the map is reloaded."},"de":{"context.update.message.title":"Ein Kartenlayer wurde gelöscht oder zurückgezogen","context.update.message.text":"Die Karte wird deshalb neu geladen."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();